module.exports = __webpack_public_path__ + "static/media/panda.f46e6800.png";